import * as React from 'react'
import { createRoot } from 'react-dom/client'

// Importing this way fixes a typescript type error with the default export
// This would run the full app as a sample from the package - it is
// mostly for illustrative purposes - you can leave it commented out, or delete
// this comment.
// const App: any = require('@paytrace/pt-skel')

import { App } from './App'
import { configSingleton } from '@paytrace/pt-skel/Config'
import { runGlobalEvents } from '@paytrace/pt-skel/GlobalEvents'

// Due to how parcel builds, only direct references are saved/injected
// The entire object can't be used freely - so any values the common package
// may need should be set here (we will need this block in each app's top level
// file).
configSingleton.env = {
  AUTH_PROVIDER: process.env.AUTH_PROVIDER,
  BFF_DOMAIN: process.env.BFF_DOMAIN,
  DEBUG_MODE: process.env.DEBUG_MODE,
  DISABLE_CROSS_SITE_SSO_STITCHING: process.env.DISABLE_CROSS_SITE_SSO_STITCHING,
  SITEMAP_LEGACY_DOMAIN: process.env.SITEMAP_LEGACY_DOMAIN,
  FINGERPRINT_API_KEY: process.env.FINGERPRINT_API_KEY,
}

// Check session validity when a user re-toggles the tab with the app
runGlobalEvents()

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render((<App/>) as any)
